import { render, staticRenderFns } from "./imageMarkWrapper1.vue?vue&type=template&id=0634477e&scoped=true&"
import script from "./imageMarkWrapper1.vue?vue&type=script&lang=js&"
export * from "./imageMarkWrapper1.vue?vue&type=script&lang=js&"
import style0 from "./imageMarkWrapper1.vue?vue&type=style&index=0&id=0634477e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634477e",
  null
  
)

export default component.exports